// moveNode — VQE-Edit edit-action: move the WHERE-tree node at `fromPath` to
// position `toIndex` within the group at `toParentPath`. This slice supports
// in-group reorder (toParentPath === the node's parent); SR-Edit no-ops a
// cross-group move. Delegates to SR-Edit `move-node` via `commitEdit`.

import type { BooleanClauseTarget, NodePath } from '../../../../sql-resolver/types/structuralEdit';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

/**
 * Reorder the node at `fromPath` to `toIndex` within `toParentPath`, in the
 * WHERE (default) or HAVING (`clause: 'having'`) tree. No-op (SR-Edit returns
 * no planned edits) for a root move, a cross-group move, an out-of-range
 * index, or `fromIndex === toIndex`.
 */
export async function moveNode(
  fromPath: NodePath,
  toParentPath: NodePath,
  toIndex: number,
  ctx: CommitEditCtx,
  clause?: BooleanClauseTarget,
): Promise<void> {
  await commitEdit({ op: 'move-node', fromPath, toParentPath, toIndex, clause }, ctx);
}
